import routes from '../routes';

export const signOut = () => {
  localStorage.clear();
  window.location.replace(routes.client.home);
};
